const LOGIN_ROUTE = { path: '/account/login' };
const HOME_ROUTE = { path: '/' };
const LOGOUT_ROUTE = { path: '/account/logout' };

// get auth meta from down to top
function getCumulativeAuthMeta(matchedRoutes) {
  if (matchedRoutes.some(route => route.meta.auth === false)) return false;

  if (
    matchedRoutes.every(
      route => route.meta.auth === undefined || route.meta.auth === null,
    )
  )
    return undefined;

  return matchedRoutes.reduce((acc, { meta: { auth } = {} }) => {
    if (Array.isArray(auth)) acc.push(auth);
    return acc;
  }, []);
}

function authGuard({ to, next, auth }) {
  const authMeta = getCumulativeAuthMeta(to.matched);

  if (authMeta === undefined) return next(); // Nothing specified

  if (authMeta === false) {
    if (auth.isLoggedIn) return next(HOME_ROUTE);
    return next();
  }

  const isLogoutRoute = to.path === LOGOUT_ROUTE.path;
  auth.redirectAfterLogin = isLogoutRoute ? null : to.fullPath;

  if (!auth.isLoggedIn) return next(LOGIN_ROUTE);
  if (authMeta === true || !authMeta.length) return next();
  if (authMeta.every(innerAuthMeta => auth.check(innerAuthMeta))) return next();

  return next(HOME_ROUTE);
}

export default function registerRouterGuard({ router, auth }) {
  router.beforeEach(async (to, from, next) => {
    if (!auth.ready) {
      return auth.onReady(() => authGuard({ to, next, auth }));
    }

    authGuard({ to, next, auth });
  });
}
